import '@/index.css'

let mounted = false

async function mountApp() {
  if (mounted) return
  mounted = true

  try {
    const [reactModule, reactDomModule, appModule] = await Promise.all([
      import('react'),
      import('react-dom/client'),
      import('@/App.jsx'),
    ])

    const React = reactModule.default
    const { createRoot } = reactDomModule
    const App = appModule.default

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        createRoot(document.getElementById('root')).render(
          React.createElement(App)
        )
      })
    })
  } catch (error) {
    mounted = false
    console.error('App bootstrap failed:', error)
  }
}

if (import.meta.env.DEV || window.__appStylesReady) {
  mountApp()
} else {
  window.addEventListener('app-styles-ready', mountApp, { once: true })

  // Keep the static first-screen shell visible while the app/CSS loads.
  window.setTimeout(mountApp, 3000)
}
